import React, { useEffect, useRef } from 'react';

const YouTubePlayer = ({ videoId, onPlayerReady }) => {
  const playerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Wait until YT is loaded
    const loadPlayer = () => {
      if (!window.YT || !window.YT.Player) {
        setTimeout(loadPlayer, 100);
        return;
      }

      if (containerRef.current) {
        playerRef.current = new window.YT.Player(containerRef.current, {
          height: '100%',
          width: '100%',
          videoId,
          events: {
            onReady: (event) => {
              onPlayerReady(event.target);
            },
          },
          playerVars: {
            modestbranding: 1,
            rel: 0,
            playsinline: 1,
            autoplay: 1,
            
          },
        });
      }
    };

    // Load the API if it hasn't been loaded yet
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
    }

    loadPlayer();
  }, [videoId, onPlayerReady]);

  return <div ref={containerRef} />;
};

export default YouTubePlayer;